import React from 'react';

const LanguageBadge = ({ text }) => {
  return <div className='language-badge'>{text}</div>;
};

export default LanguageBadge;
